import { styled } from '@zoopla-eng/zds-components/themes';

export const NewHomesSectionSubtitle = styled('p', {
    fontGroup: 'whisk',
    color: '$textTitle',
    fontWeight: '$semiBold'
});
